import { useAuth } from '@/app/hooks/useAuth'
import { ReportWithdraws } from '@/app/services/reportService/reportWithdraws'
import { formatCpfNumber } from '@/app/utils/cpfFormater'
import { formatMoneyValue } from '@/app/utils/formatMoneyValue'
import { formatName } from '@/app/utils/formatName'
import { obscure } from '@/app/utils/obscure'
import Status from '@/view/components/Status'
import { createColumnHelper } from '@tanstack/react-table'
import { format } from 'date-fns'
import { useMemo } from 'react'

export const TableReportWithdrawsColumnsDefinition = () => {
  const { isAdmin } = useAuth()
  const columnHelper = createColumnHelper<ReportWithdraws>()

  const columns = useMemo(
    () => [
      columnHelper.accessor('user', {
        id: 'vendedor',
        header: () => (
          <div className="flex flex-col items-start pl-2">
            <div>Vendedor</div>
            <div className="block text-black04 min-[912px]:hidden">CPF</div>
          </div>
        ),
        cell: ({ row }) => (
          <div className="flex flex-col items-start gap-1 pl-4">
            {row.original.user && <p>{formatName(row?.original?.user)}</p>}
            <div className="block text-start text-black04 min-[912px]:hidden">
              {row.original.cpf && (
                <>
                  {!isAdmin
                    ? obscure(row.original.cpf)
                    : formatCpfNumber(row.original.cpf)}
                </>
              )}
            </div>
          </div>
        ),
      }),
      columnHelper.accessor('cpf', {
        id: 'cpf',
        header: () => (
          <div className="hidden pl-2 text-start min-[912px]:block">CPF</div>
        ),
        cell: ({ row }) => (
          <div className="hidden pl-4 text-start min-[912px]:block">
            {row.original.cpf && (
              <>
                {!isAdmin
                  ? obscure(row.original.cpf)
                  : formatCpfNumber(row.original.cpf)}
              </>
            )}
          </div>
        ),
      }),

      columnHelper.accessor('value', {
        id: 'value',
        header: () => (
          <div>
            <div>Valor</div>
            <div className="block text-black04 min-[912px]:hidden">Taxa</div>
          </div>
        ),
        cell: ({ row }) => (
          <div className="flex flex-col items-start">
            <p className="flex gap-3">{formatMoneyValue(row.original.value)}</p>
            <p className="text-center text-black04 min-[912px]:hidden">
              {row.original.pix_fee
                ? formatMoneyValue(row.original.pix_fee)
                : '-'}
            </p>
          </div>
        ),
      }),
      columnHelper.accessor('pix_fee', {
        id: 'pix_fee',
        header: () => (
          <div className="hidden text-center min-[912px]:block">Taxa</div>
        ),
        cell: ({ row }) => (
          <div className="hidden text-center min-[912px]:block">
            {row.original.pix_fee
              ? formatMoneyValue(row.original.pix_fee)
              : '-'}
          </div>
        ),
      }),

      columnHelper.accessor('updatedAt', {
        id: 'data',
        header: () => <div className="hidden text-center sm:block">Data</div>,
        cell: ({ row }) => (
          <div className="hidden text-center sm:block">
            {format(new Date(row.original.updatedAt), 'dd/MM/yyyy, HH:mm')}
          </div>
        ),
      }),
      columnHelper.accessor('status', {
        id: 'status',
        header: () => (
          <div className="flex flex-col items-center">
            <div className="text-center">Status</div>
            <div className="block text-black04 sm:hidden">Data</div>
          </div>
        ),
        cell: ({ row }) => (
          <div className=" text-center ">
            <Status status={row.original.status as never} />
            <div className="block text-center text-black04 sm:hidden">
              {format(new Date(row.original.updatedAt), 'dd/MM/yyyy, HH:mm')}
            </div>
          </div>
        ),
      }),
    ],
    [columnHelper, isAdmin],
  )

  return {
    columns,
  }
}
